import { CreateEntityTabPage } from "../shared/CreateEntityTabPage";

export function CreateCustomerPage(): JSX.Element {
  return <CreateEntityTabPage entityType="customer" />;
}
